document.addEventListener('DOMContentLoaded', function () {

  const originalToc = document.querySelector('.phytva-toc');
  const originalNav = document.querySelector('.phytva-toc-nav');

  if (!originalToc || !originalNav) return;


  /* =====================================================
     1. 自动生成手机 floating TOC
     ===================================================== */

  const mobileToc = document.createElement('div');

  mobileToc.className = 'phytva-mobile-toc';

  mobileToc.innerHTML = `
    <button
      class="phytva-mobile-toc-toggle"
      type="button"
      aria-expanded="false"
      aria-label="Open article navigation"
    >
      <span>Jump to</span>
      <span class="phytva-mobile-toc-chevron"></span>
    </button>

    <nav
      class="phytva-mobile-toc-panel"
      aria-label="Article navigation"
    >
      ${originalNav.innerHTML}
    </nav>
  `;

  document.body.appendChild(mobileToc);


  const toggle =
    mobileToc.querySelector('.phytva-mobile-toc-toggle');

  const panel =
    mobileToc.querySelector('.phytva-mobile-toc-panel');


  /* =====================================================
     2. 找 Shopify Header 的实际底部
     ===================================================== */

  function getHeaderBottom() {

    const possibleHeaders = [
      document.querySelector('sticky-header'),
      document.querySelector('.section-header'),
      document.querySelector('#shopify-section-header'),
      document.querySelector('.header-wrapper')
    ].filter(Boolean);

    let bottom = 0;

    possibleHeaders.forEach(function(header) {

      const rect = header.getBoundingClientRect();

      /*
        只计算目前真正位于屏幕顶部区域的 header
      */
      if (
        rect.bottom > 0 &&
        rect.top < window.innerHeight
      ) {

        bottom = Math.max(bottom, rect.bottom);

      }

    });

    return Math.max(0, Math.round(bottom));

  }


  /* =====================================================
     3. 判断原 Jump to 是否已经滚出顶部
     ===================================================== */

  function updateFloatingToc() {

    if (window.innerWidth >= 990) {

      mobileToc.classList.remove('is-visible');
      mobileToc.classList.remove('is-open');

      return;

    }


    const headerBottom = getHeaderBottom();

    document.documentElement.style.setProperty(
      '--phytva-mobile-toc-top',
      headerBottom + 'px'
    );


    const tocRect =
      originalToc.getBoundingClientRect();


    /*
      当原始 Jump to 的底部已经经过 Header 底部，
      显示 floating Jump to。
    */
    const shouldShow =
      tocRect.bottom <= headerBottom;


    if (shouldShow) {

      mobileToc.classList.add('is-visible');

    } else {

      mobileToc.classList.remove('is-visible');
      mobileToc.classList.remove('is-open');

      toggle.setAttribute(
        'aria-expanded',
        'false'
      );

    }

  }


  /* =====================================================
     4. 点击 Jump to 展开 / 收起
     ===================================================== */

  toggle.addEventListener('click', function () {

    const isOpen =
      mobileToc.classList.toggle('is-open');

    toggle.setAttribute(
      'aria-expanded',
      isOpen ? 'true' : 'false'
    );

  });


  /* =====================================================
     5. 点击某个锚点后自动收起
     ===================================================== */

  panel.addEventListener('click', function (event) {

    const link =
      event.target.closest('a[href^="#"]');

    if (!link) return;


    mobileToc.classList.remove('is-open');

    toggle.setAttribute(
      'aria-expanded',
      'false'
    );

  });


  /* =====================================================
     6. 页面滚动 / 改尺寸时更新
     ===================================================== */

  window.addEventListener(
    'scroll',
    updateFloatingToc,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    updateFloatingToc
  );


  updateFloatingToc();

});


document.addEventListener('DOMContentLoaded', function () {
  const article = document.querySelector('.phy-article');

  if (!article) return;

  const main = article.querySelector('.phytva-blog-main');
  const toc = article.querySelector('.phytva-toc-nav');

  if (!main || !toc) return;

  const headings = Array.from(
    main.querySelectorAll('h2[id]')
  );

  const tocLinks = Array.from(
    toc.querySelectorAll('a[href^="#"]')
  );

  if (!headings.length || !tocLinks.length) return;

  /*
   * 建立：
   * h2 id -> 对应 TOC link
   */
  const linkMap = new Map();

  tocLinks.forEach(function (link) {
    const id = decodeURIComponent(
      link.getAttribute('href').slice(1)
    );

    linkMap.set(id, link);
  });


  /*
   * 设置当前 active link
   */
  function setActive(id) {
    tocLinks.forEach(function (link) {
      const isActive =
        decodeURIComponent(
          link.getAttribute('href').slice(1)
        ) === id;

      link.classList.toggle('is-active', isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }


  /*
   * 根据滚动位置判断当前 H2
   *
   * 这个 offset 要与你顶部 Shopify sticky header
   * 保持协调。
   *
   * PC 大约 120px
   * Mobile 因为有 floating Jump to，可适当更大。
   */
  function getScrollOffset() {
    if (window.innerWidth <= 989) {
      return 150;
    }

    return 130;
  }


  function updateActiveFromScroll() {
    const offset = getScrollOffset();

    let currentHeading = headings[0];

    /*
     * 找出最后一个已经经过阅读基准线的 H2
     */
    for (let i = 0; i < headings.length; i++) {
      const heading = headings[i];

      const top =
        heading.getBoundingClientRect().top;

      if (top <= offset) {
        currentHeading = heading;
      } else {
        break;
      }
    }

    /*
     * 如果还没有滚到第一个 H2，
     * 可以选择不高亮任何目录。
     */
    const firstTop =
      headings[0].getBoundingClientRect().top;

    if (firstTop > offset) {
      tocLinks.forEach(function (link) {
        link.classList.remove('is-active');
        link.removeAttribute('aria-current');
      });

      return;
    }

    setActive(currentHeading.id);
  }


  /*
   * 点击 Jump to 时立即更新 active
   */
  tocLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      const id = decodeURIComponent(
        link.getAttribute('href').slice(1)
      );

      setActive(id);
    });
  });


  /*
   * 用 requestAnimationFrame 防止 scroll 事件过密
   */
  let ticking = false;

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        updateActiveFromScroll();
        ticking = false;
      });

      ticking = true;
    }
  }


  window.addEventListener(
    'scroll',
    onScroll,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    updateActiveFromScroll
  );


  /*
   * 页面首次加载
   */
  updateActiveFromScroll();


  /*
   * 如果页面通过 #anchor 打开，
   * 初始化对应 active
   */
  if (window.location.hash) {
    const hashId = decodeURIComponent(
      window.location.hash.slice(1)
    );

    if (linkMap.has(hashId)) {
      setActive(hashId);
    }
  }
});